<template>
  <div v-if="user.uid">
    <Lotery />
    <NewRewardModal />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Lotery from './components/Lotery.vue';
import loteryStore from './store/loteryStore';
import NewRewardModal from './components/NewRewardModal.vue';

export default {
  components: {
    NewRewardModal,
    Lotery,
  },
  computed: {
    ...mapState({
      user: (state) => state.userStore.user,
    }),
  },
  created() {
    this.$store.registerModule('loteryStore', loteryStore);
  },
  destroyed() {
    this.$store.unregisterModule(['loteryStore']);
  },
};
</script>
